 
<template>
  <div>
    <div class="title-bar detail clearfix">
      <div class="module pull-left">
        {{ $t("editEAN") }}
    </div>
      <div style="float:right;">
        <el-button   plain size="mini" @click="addEAN('addEANCodeForm')">{{ $t("save") }}
         
        </el-button>
        <el-button plain size="mini" @click="cancelOperation">{{ $t("cancel") }}
        
        </el-button>
      </div>
    </div>

 <div class="data-list detail">
    <div class="detail-header">
      <span>EAN码信息</span>
      <div class="detail-triangle"></div>
    </div>
    
    <div class="detail-content">
      <el-form class="detail-form" size="small"  ref="addEANCodeForm" :model="EANCodeInfo" label-width="120px" :rules="rules" status-icon>
        <el-row>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" >      
        <el-form-item :label="this.$t('EANCode')" prop="EANCode" >
          
          <el-input v-model="EANCodeInfo.EANCode" disabled="disabled"></el-input>
          
        </el-form-item>
       
        <el-form-item :label="this.$t('AmountPerPackage')" prop="AmountPerPackage" >
         
           
        <el-input  v-model="EANCodeInfo.AmountPerPackage" ></el-input>
         
        
          
        </el-form-item>   
        
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" >
        <el-form-item :label="this.$t('ProductLongCode')" prop="ProductLongCode" >
          
          <el-input  v-model="EANCodeInfo.ProductLongCode" ></el-input>
          
        </el-form-item>

        <el-form-item :label="this.$t('ProductShortCode')" prop="ProductShortCode">
           
          <el-input  v-model="EANCodeInfo.ProductShortCode" ></el-input>
           
        </el-form-item>       
      </el-col>   
          
          
        <el-col :xs="24" :sm="12" :md="12" :lg="12" >
        <el-form-item :label="this.$t('ProductSerials')" prop="ProductSerials">
         
          <el-input  v-model="EANCodeInfo.ProductSerials" ></el-input>
        </el-form-item>       
      </el-col>   

       <el-col :xs="24" :sm="12" :md="12" :lg="12" >
        <el-form-item :label="this.$t('SuggestedRetailPrice')" prop="SuggestedRetailPrice">
         
          <el-input v-model="EANCodeInfo.SuggestedRetailPrice"></el-input>
        </el-form-item>       
      </el-col> 
       
        </el-row>  
    </el-form>
     </div>
  </div>
  
</div>
</template>


<script>
import _ from "lodash";
export default {
  name: "EditEAN",
  filters: {
    rounding(value) {
      return value.toFixed(2);
    }
  },
  data() {
    return {
      EANCodeInfo: {
        EANCode: "",
        AmountPerPackage: "",
        ProductLongCode: "",
        ProductShortCode: "",
        ProductSerials: "",
        SuggestedRetailPrice: ""
      },

      rules: {
        EANCode: [
          { required: true, message: this.$t("EANCodeValidation") },
          {
            validator: (rule, value, callback) => {
              var raw = JSON.stringify(value).replace(/\"/g, "");
              var format = raw.replace(/[^0-9]/g, "");
              if (raw.length > format.length) {
                callback(new Error("EAN码只能为阿拉伯数字"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        ProductLongCode: [
          {
            required: true,
            message: this.$t("ProductLongCodeValidation")
          },
          {
            pattern: new RegExp(/[-]/),
            message: this.$t("必须包含数字与‘-’"),
            trigger: "blur"
          },

          {
            validator: (rule, value, callback) => {
              var raw = JSON.stringify(value).replace(/\"/g, "");
              var format = raw.replace(/[^0-9-]/g, "");
              if (raw.length > format.length) {
                callback(new Error("必须包含数字与‘-’"));
              } else {
                if (
                  raw.charAt(raw.length - 1) === "-" ||
                  raw.charAt(0) === "-"
                ) {
                  callback(new Error("格式不正确"));
                }
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        ProductShortCode: [
          {
            required: true,
            message: this.$t("ProductShortCodeValidation")
          },
          {
            validator: (rule, value, callback) => {
              var raw = JSON.stringify(value).replace(/\"/g, "");
              var format = raw.replace(/[^0-9]/g, "");
              if (raw.length > format.length) {
                callback(new Error("短号只能为阿拉伯数字"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        ProductSerials: [
          { required: true, message: this.$t("ProductSerialsCodeValidation") },
          {
            validator: (rule, value, callback) => {
              var raw = JSON.stringify(value).replace(/\"/g, "");
              var format = raw.replace(/[^0-9]/g, "");
              if (raw.length > format.length) {
                callback(new Error("系列号只能为阿拉伯数字"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        AmountPerPackage: [
          {
            required: true,
            message: this.$t("AmountPerPackageValidation")
          },

          {
            validator: (rule, value, callback) => {
              var raw = JSON.stringify(value).replace(/\"/g, "");
              var format = raw.replace(/[^0-9]/g, "");
              if (raw.length > 9) {
                callback(new Error("每盒产品数量过大"));
              }
              if (raw.length > format.length) {
                callback(new Error("请输入一个整数"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        SuggestedRetailPrice: [
          {
            required: true,
            message: this.$t("SuggestedRetailPriceValidation")
          },

          {
            validator: (rule, value, callback) => {
              var raw = JSON.stringify(value).replace(/\"/g, "");
              var format = raw.replace(/[^\d+(\.\d+)?$]/g, "");

              if (raw.length > format.length) {
                callback(new Error("请输入一个浮点数"));
              }

              var index = raw.indexOf(".");
              if (index != -1) {
                var arrStr = [];
                arrStr = raw.split(".");
                if (arrStr[1] && arrStr[1].length > 2) {
                  callback(new Error("请输入一个2位小数"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.$axios
      .get(`api/eancodes/${this.$route.params.EANId}`)
      .then(response => {
        this.EANCodeInfo.Id = response.data.Id;
        this.EANCodeInfo.EANCode = response.data.EANCode;
        this.EANCodeInfo.ProductLongCode = response.data.ProductLongCode;
        this.EANCodeInfo.ProductShortCode = response.data.ProductShortCode;
        this.EANCodeInfo.AmountPerPackage = response.data.AmountPerPackage;
        this.EANCodeInfo.CashbackInformation =
          response.data.CashbackInformation;
        this.EANCodeInfo.ProductSerials = response.data.ProductSerials;
        this.EANCodeInfo.SuggestedRetailPrice = response.data.SuggestedRetailPrice;
      });
  },
  methods: {
    addEAN(addEANCodeForm) {
      this.$refs[addEANCodeForm].validate(valid => {
        if (valid) {
          this.$axios
            .post("api/eancodes/addoredit", this.EANCodeInfo)
            .then(response => {
              this.$message({
                message: this.$t("EANAEditSuccessfully"),

                type: "success",
                showClose: true,
                duration: 2000
              });
              this.$router.push({ name: "EANCode" });
            })
            .catch(err => {
              this.$message({
                message: this.$t(err.response.statusText),
                type: "error",
                showClose: true,
                duration: 2000
              });
            });
        } else {
          this.$message({
            message: this.$t("operationFailure"),
            type: "error",
            showClose: true,
            duration: 2000
          });
        }
      });
    },
    handlefocus(ev) {
      this.EANCodeInfo.AmountPerPackage = parseInt(
        this.EANCodeInfo.AmountPerPackage
      );
    },
    cancelOperation() {
      this.$router.push({ name: "EANCode" });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/application/EANCode/EditEAN.vue